import React from 'react'
import { Link } from 'react-router-dom'

const Index = () => {
  return (
    <div className='conainer-fluid' >
      <ol className="breadcrumb p-2">
        <li className="breadcrumb-item"><Link to='/' className="accentColor" >Home</Link></li>
        <li className="breadcrumb-item"><Link to='/' className="accentColor" >RentYourcar</Link></li>
        <li className="breadcrumb-item" aria-current="page">Dashboard</li>
      </ol>
      <div className='row' >
        <div className='col-' ></div>
      </div>
    </div>
  )
}

export default Index
